const seoTextsToggle = {
    'short': `
			<p>
				Підключення до акційного тарифу «Рік Гігабіту» вартістю 1099 грн/рік можливе тільки для нових абонентів. 
			Акційні умови діють протягом 1 (одного) року з моменту підключення, 
			після закінчення акційного періоду абонент автоматично переводиться на тарифний план «Чистий Гігабіт».
			</p>`,
    'full': `
		<p>
			Підключення до акційного тарифу «Рік Гігабіту» вартістю 1099 грн/рік можливе тільки для нових абонентів. 
			Акційні умови діють протягом 1 (одного) року з моменту підключення, 
			після закінчення акційного періоду абонент автоматично переводиться на тарифний план «Чистий Гігабіт».
		</p>
		<p>
			Вартість підключення тарифу «Рік Гігабіту» складає 1 грн. Всі ціни наведені в гривні з урахуванням ПДВ. 
			Ви можете підключитися до акційного тарифу «Рік Гігабіту» з 30 грудня 2021 р. до 10 березня 2022 р.
		</p>`
}
export default seoTextsToggle;